import { TranslationUserRegisterMessages, UserRegisterMessages } from "../interfaces";

export const messages: TranslationUserRegisterMessages = {
  [UserRegisterMessages.titleCreate]: "Criar usuário",
  [UserRegisterMessages.titleEdit]: "Editar usuário",
  [UserRegisterMessages.stepTabFormUser]: "Dados do usuário",
  [UserRegisterMessages.stepTabAddUserToRoles]: "Adicionar em grupos",
  [UserRegisterMessages.stepTabModuleAccess]: "Acesso a módulos",
  [UserRegisterMessages.roleNotSelected]: "Não é possível prosseguir, pois nenhum grupo foi selecionado",
  [UserRegisterMessages.roleNotFound]: "O grupo selecionado não foi encontrado",
  [UserRegisterMessages.noRolesRegistered]: "Não há grupos registrados",
  [UserRegisterMessages.confirmUserEditModalTitle]: "Confirmação de alteração",
  [UserRegisterMessages.confirmUserEditModalDescription]: "Você está salvando um usuário sem grupo."
    + " Se ele possuir permissões personalizadas, elas serão perdidas. Tem certeza de que deseja continuar?",
  [UserRegisterMessages.confirmUserInactivateModalTitle]: "Confirmação de inativação",
  [UserRegisterMessages.confirmUserInactivateModalDescription]: "Ao confirmar, o usuário será inativado em todas as soluções Topcon. "
      + "Você tem certeza que deseja continuar?",
  [UserRegisterMessages.moduleAccessTitle]: "Acesso a módulos",
  [UserRegisterMessages.moduleAccessCaption]: "Define quais produtos o usuário pode entrar. Grupos e permissões ficam dentro de cada produto"
    + " e exigem que o acesso ao módulo seja concedido primeiro.",
  [UserRegisterMessages.moduleAccessNoModules]: "Nenhum módulo disponível para esta empresa.",
  [UserRegisterMessages.moduleAccessSaveSuccess]: "Acessos a módulos atualizados.",
  [UserRegisterMessages.moduleAccessSaveError]: "Falha ao salvar acessos a módulos.",
  [UserRegisterMessages.moduleAccessNoChanges]: "Nenhuma alteração pendente.",
  [UserRegisterMessages.moduleAccessAdminNotice]: "Este usuário é administrador e tem acesso automático a todos os módulos"
    + " contratados pela empresa. Não é possível alterar os acessos manualmente."
};